import { screen } from 'components/styles/variables';
import Dialog from 'components/Dialog/ReduxContainer';
import { useDispatch } from 'react-redux';
import {
  signInWithGoogle,
  signInWithFacebook,
  createAccountByEmail,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from 'redux-implementations/auth';
import { resolve } from 'styled-jsx/css';
import { DialogNames } from 'redux-implementations/dialog';

import { CreateEmailAccountParams } from 'types/Auth';
import Flow from './Flow';

const dialogCss = resolve`
@media (min-width: ${screen.smMin}) {
  .dialog {
    width: 375px!important;
  }
}

.dialog {
  padding: 10px;
}
`;

export default function AuthDialog(): JSX.Element {
  const dispatch = useDispatch();
  const dispatchSignInWithGoogle = (): void => {
    dispatch(signInWithGoogle());
  };
  const dispatchSignInWithFacebook = (): void => {
    dispatch(signInWithFacebook());
  };
  const dispatchLoginWithEmail = ({
    email,
    password,
  }: {
    email: string;
    password: string;
  }): void => {
    dispatch(signInWithEmailAndPassword(email, password));
  };
  const dispatchResetPassword = ({ email }: { email: string }): void => {
    dispatch(sendPasswordResetEmail(email));
  };
  const dispatchCreateAccountByEmail = ({
    email,
    password,
    acceptEmails,
  }: CreateEmailAccountParams): void => {
    dispatch(createAccountByEmail({ email, password, acceptEmails }));
  };

  return (
    <Dialog name={DialogNames.Auth} className={dialogCss.className}>
      <Flow
        onClickGoogle={dispatchSignInWithGoogle}
        onClickFacebook={dispatchSignInWithFacebook}
        onSubmitLoginWithEmail={dispatchLoginWithEmail}
        onSubmitResetPassword={dispatchResetPassword}
        onSubmitCreateAccountByEmail={dispatchCreateAccountByEmail}
      />
      {dialogCss.styles}
    </Dialog>
  );
}
